import commonUtil from '../../../../utils/commonUtil';

export const GIFT_REGISTRY_ADDRESS_LOAD = 'GIFT_REGISTRY_ADDRESS_LOAD';
export const GIFT_REGISTRY_ADDRESS_LOAD_SUCCESS = 'GIFT_REGISTRY_ADDRESS_LOAD_SUCCESS';
export const GIFT_REGISTRY_ADDRESS_LOAD_FAIL = 'GIFT_REGISTRY_ADDRESS_LOAD_FAIL';

export function isGiftRegistryAddressLoaded(globalState) {
  return globalState.SelectTypeEvent && globalState.SelectTypeEvent.loaded;
}

export function loadGiftRegistryAddress() {
  const _giftRegistryInput = {};
  _giftRegistryInput.brandName = commonUtil.getBrand();
  _giftRegistryInput.channel = commonUtil.getChannel().toUpperCase();

  return {
    types: [GIFT_REGISTRY_ADDRESS_LOAD, GIFT_REGISTRY_ADDRESS_LOAD_SUCCESS, GIFT_REGISTRY_ADDRESS_LOAD_FAIL],
    promise: client => client.post('/api/currentUser/getAddresses', {
      data: (_giftRegistryInput),
    }),
    // TODO: This is local srvice.
    // promise: client => client.get('/api/giftRegistryAddress'),
  };
}
